module.exports = __webpack_public_path__ + "media/bootstrap-icons/hand-thumbs-down-a020aec9.svg";